export enum addBatchAttachmentFormFields {
  batchAttachmentType = 'batchAttachmentType',
  documentLink = 'documentLink',
}
